<script setup>
    import { computed, ref } from 'vue'
    import SingleEdit from '@/js/components/Common/SingleEdit.vue'

    const props = defineProps({
        modulDauer: {
            type: String,
            required: true
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const emit = defineEmits(['modulDauerSaved'])

    const title = computed(() => (props.language === 'englisch' ? 'Module duration | Moduldauer' : 'Moduldauer'))

    const allowEdit = computed(() => {
        return store.getters['security/isAdmin']
    })

    let editModulDauer = ref('')

    function handleEditStart() {
        editModulDauer.value = props.modulDauer
    }

    function handleEditAbort() {
        editModulDauer.value = ''
    }

    const saveModulDauer = () => {
        emit('modulDauerSaved', editModulDauer.value)
    }
</script>

<template>
    <single-edit
        :entry="modulDauer"
        edit-key="modulDauer"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="saveModulDauer"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-text-field v-model="editModulDauer" density="default" class="w-100 h-100" />
        </template>
    </single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
